import { render, staticRenderFns } from "./category-labels.vue?vue&type=template&id=352b9990"
import script from "./category-labels.vue?vue&type=script&lang=js"
export * from "./category-labels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports